import { loadStudentActivationFunctionality } from "../../Administration/StudentActivation/ActivateFunctionality";
import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { activateTutorForCourse } from "../../Utils/TutorManagement/activateTutorForCourse";
import { inviteTutorToCourse } from "../../Utils/TutorManagement/inviteTutorToCourse";
import { removeExistingTutorInvitation } from "../../Utils/TutorManagement/removeExistingTutorInvitation";
import { removeTutorFromCourse } from "../../Utils/TutorManagement/removeTutorFromCourse";
import { removeTutorInvitation } from "../../Utils/TutorManagement/removeTutorInvitation";
import { UserManagement } from "../../Utils/UserManagement/UserManagement";
import { checkEmail, successToast } from "../../Utils/utils";
import { deleteCourse } from "./DeleteCourse";
import { changeCourseListItem, fillActivateStudents, fillAdminCourseDetails, fillAvailableTutors } from "./Fills";
import { loadDt } from "./loadDt";


export class AdminCourseManagement {
    courseId:number;
    schoolId:number;
    wrapper:JQuery;

    constructor(courseId, schoolId, wrapper) {
        this.courseId = courseId;
        this.schoolId = schoolId;
        this.wrapper = $(wrapper);

        this.activator = loadStudentActivationFunctionality(this.courseId, 'admin')
        this.userManager = new UserManagement(this.courseId, wrapper);

        this.addListeners();
        this.loadDatatable();
    }

    loadDatatable(){
        const table = $("#card-activate-students").find("table")
        table.DataTable(loadDt(table));
    }

    createCourse(schoolId, btn){
        const longName = $("#course-name-long").val();

        const url = '/course/create/' + schoolId.toString();

        const success = function (data){
            $("#course-name-long").val("");
                    // self.fillAdminCourseList();
                    successToast("Kurs " + longName + " wurde erstellt", "Erfolg", 10000, true);
                    setTimeout(() => {
                        location.reload();
                    }, 1400);
        }

        const data = {
            name: longName,
        }

        ajaxRequest(url, success, data, btn);

    }

    addListeners(){
        const self = this;
        this.wrapper.on("click", ".create-course", function(){
            self.createCourse(self.schoolId, $(this));
        })
        this.wrapper.find("#course-list").on("click", ".m-f-t-item", function(){
            const courseId = changeCourseListItem($(this));
            self.updateCourseId(courseId);
            self.instanceManagementInitCourse(self.courseId);
        })
        this.wrapper.on("click", ".deactivate-tutor", function(){
            const userId = $(this).attr("data-user");
            const confirmed = confirm("Sicher, dass du diese/-n Tutor/-in deaktivieren möchtest?");
            if (confirmed){
                removeTutorFromCourse(userId, self.courseId, $(this));
            }
        })
        this.wrapper.on("click", ".deactivate-tutor-vormerkung", function(){
            const mail = $(this).attr('data-mail');
            const confirmed = confirm("Sicher, dass du das Angebot an " + mail + " zurückziehen möchtest?");
            if (confirmed) {
                removeTutorInvitation(mail, self.courseId, $(this));
            }
        });
        this.wrapper.on("click", ".deactivate-tutor-id", function(){
            const id = $(this).attr('data-id');
            const name = $(this).parent().prev().find(".name").html();
            const confirmed = confirm("Sicher, dass du das Angebot an " + name + " zurückziehen möchtest?");
            if (confirmed) {
                removeExistingTutorInvitation(id, self.courseId, $(this));
            }
        });
        this.wrapper.on("click", ".fill-available-tutors", function(){
            fillAvailableTutors(self.courseId);
        });
        this.wrapper.on("click", ".activate-tutor-for-course", function(){
            const userId = $(this).attr("data-user");
            const userName = $(this).parent().parent().children().first().html();
            activateTutorForCourse(userId, self.courseId, userName, $(this));
        });
        this.wrapper.on("click", ".activate-new-tutor-for-course", function(){
            const email = $("#new-tutor-mail").val();
            const checkPassed = checkEmail(email);
            if (checkPassed){
                inviteTutorToCourse(email, self.courseId, $(this));
            }
        });
        this.wrapper.on("click", ".delete-course", function(){
            const courseName = $("#card-course-details .card-subtitle").html();
            const confirmed = confirm("Bist du dir sicher, dass du den Kurs \"" + courseName + "\" löschen möchtest?");
            if (confirmed) {
                deleteCourse(self.courseId, $(this))
            }
        })
    }

    updateCourseId(courseId){
        this.courseId = courseId;
        this.activator.courseId = courseId;
        this.userManager.courseId = courseId;
    }

    instanceManagementInitCourse(courseId){
        this.updateCourseId(courseId);
        fillActivateStudents(courseId);
        fillAdminCourseDetails(courseId);
    }

    // fillAdminCourseList(){


    //     var self = this;
    //     let config = {
    //         data: {
    //             'action': 'fill_admin_course_list',
    //         },
    //         success: function(data){
    //             if (data.success){
    //                 $("#admin-course-list").html(data.html);
    //                 self.courseId = data.firstCourseId; // TODO Check
    //             } else {
    //                 errorToast("Keine Kurse gefunden", "Fehler", 14000);
    //             }
    //         }
    //     }
    //     ajax(config);
    // }
}


